import classNames from 'classnames/bind';

import SwitchButton from '../../../MainTrending/TrendingFilters/TrendingPersonalisationFilter/SwitchButton';
import withComponentName from '../../../../decorators/withComponentName';

import Styles from '../../story-filters-styles.module.scss';

const cx = classNames.bind(Styles);

const GeneralSettings = ({
  onChangeSwitchButton,
  switchId, status, item, title,
}) => {
  const advancedSettignsItemClass = cx({
    'source-settings-items--item': true,
  });

  return (
    <div className={advancedSettignsItemClass}>
      <div className={Styles.main}>
        <span>{title}</span>
        <SwitchButton
          id={switchId}
          status={status}
          item={item}
          onChange={onChangeSwitchButton}
          className="general"
        />
      </div>
    </div>
  );
};

export default withComponentName(GeneralSettings);
